<input  [nbDatepicker]="formControl" nbInput status="basic" fieldSize="small" (change)="dateChange($event)"/>
<nb-date-timepicker withSeconds singleColumn (dateTimeChange)="dateChange($event)" #formControl></nb-date-timepicker>
